import React, {useContext, useEffect} from 'react';
import {
  useHistory , useRouteMatch, Switch, useLocation,
  Route,
} from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {store} from "../store";
import Schedule from "./Schedule/Schedule";
import Approvals from "./Appovals/Approvals";
import Performance from "../Performance/Performance";
import {hasScope, SCOPES} from "../helpers/scopes";
import MyShifts from "./MyShifts/MyShifts";
import {Overview} from "./Overview/Overview";
import {UserSettings} from "./UserSettings/UserSettings";
import {removeLastUrlLoc} from "../helpers/utils/utils";
import { Mappings } from 'Settings/Mappings';
import { ShiftAttributes } from 'Settings/ShiftAttributes';
import PayRole from './PayRole/PayRole';

export default function Rota() {
  const history = useHistory();
  let location = useLocation();
  let match = useRouteMatch();
  const {state} = useContext(store);
  let customer = window.location.pathname.split('/')[1];
  let tabPageMargin = '32px 4px 0';
  const [value, setValue] = React.useState(removeLastUrlLoc(location.pathname));

  useEffect(() => {
    setValue(removeLastUrlLoc(location.pathname));
  }, [location]);

  const handleChange = (event, newValue) => {
    history.push( newValue);
  };

  return (
    <div>
      {state.user.isSiteAdmin && state.site.normalName &&
      <React.Fragment>
        <div style={{borderBottom:'1px solid #ccc', marginTop:'1rem'}}>
        {<Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
        >
          {hasScope(state.user, SCOPES.ROTA_ADMIN_READ) && <Tab label="Analysis" value={`/${customer}/rota/payrole`}/>}
          <Tab label="Rota" value={`/${customer}/rota`}/>
        </Tabs>}
        </div>
      </React.Fragment>}

      {state.user.onRota &&
      <React.Fragment>
        <div style={{borderBottom:'1px solid #ccc', marginTop:'1rem'}}>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab label="Rota" value={`/${customer}/rota/schedule`}/>
          </Tabs>
        </div>
      </React.Fragment>}

      <div style={{margin: `${(state.user.isSiteAdmin || state.user.onRota)  && tabPageMargin}`}}>
        <Switch >
          <Route path={`${match.path}/approve`}>
            <Approvals/>
          </Route>
          <Route path={`${match.path}/payrole/:dateParam?`}>
            <Performance siteOnly />
          </Route>
          <Route path={`${match.path}/payroleold`}>
            <PayRole />
          </Route>
          <Route path={`${match.path}/schedule`}>
            <Schedule/>
          </Route>
          <Route path={`${match.path}/overview`}>
            <Overview/>
          </Route>
          <Route path={`${match.path}/settings`}>
            <UserSettings/>
          </Route>
          <Route path={`${match.path}/mappings`}>
            <Mappings/>
          </Route>
          <Route path={`${match.path}/staff`}>
            <ShiftAttributes/>
          </Route>
          <Route path={`${match.path}`}>
            {(state.user.role !== 'staff') && <Schedule/>}
            {(state.user.role === 'staff') && <MyShifts/>}
          </Route>
        </Switch>
      </div>
    </div>
  );
}
